<template>
  <div style="width: 100%;" :class="{english:lang=='EN'}">
    <div class="hidden-xs" v-if="!isMobile">
      <div class="lantern" :class="detailContent.id">
        <div class="content" :style="{height:detailContent.model == 'card'? '30rem':'26.25rem'}">
          <div class="left wow fadeInUp">
            <p>{{$t(detailContent.title)}}</p>
            <span>{{$t(detailContent.introduction)}} </span>
            <div style="overflow:hidden">
              <div class="common-btn left-btn" @click="clickPrevItem"></div>
              <div class="common-btn right-btn" @click="clickNextItem"></div>
            </div>
          </div>
          <div class="right" v-if="detailContent.model == 'card'">
            <div class="right-content">
              <div class="bk-container"
                   :class="{bkBlue:detailContent.bkColor=='blue',bkBlack:detailContent.bkColor=='black'}"></div>
              <div class="menu">
                <div class="swiper-container">
                  <div class="swiper-wrapper" style="padding: 0.375rem 0;">
                    <div class="item swiper-slide" v-for="item in detailContent.events">
                      <img class="img-fluid" :src="item.img">
                      <div class="time">{{item.time}}</div>
                      <div class="events">{{$t(item.event)}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="right imgRight" v-if="detailContent.model == 'img'">
            <div class="right-content">
              <div class="bk-container"
                   :class="{bkBlue:detailContent.bkColor=='blue',bkBlack:detailContent.bkColor=='black'}"></div>
              <div class="menu">
                <div class="swiper-container">
                  <div class="swiper-wrapper" style="padding: 0.375rem 0;">
                    <div class="item swiper-slide" :src="item.img" v-for="(item,index) in detailContent.imgs">
                      <img style="cursor: pointer; pointer-events:auto;" class="img-fluid" :large="item.img" :preview="detailContent.id" :src="item.img">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="visible-xs" v-if="isMobile">
      <div class="lantern" :class="detailContent.id">
        <div class="content" :style="{height:detailContent.model == 'card'? '24rem':'18.9rem'}">
          <div class="left wow fadeInUp">
            <p>{{$t(detailContent.title)}}</p>
            <!--            <span>{{detailContent.introduction}} </span>-->
          </div>
          <div class="right" v-if="detailContent.model == 'card'">
            <div class="right-content">
              <div class="bk-container"
                   :class="{bkBlue:detailContent.bkColor=='blue',bkBlack:detailContent.bkColor=='black'}"></div>
              <div class="menu">
                <div class="swiper-container">
                  <div class="swiper-wrapper" style="padding: 0.375rem 0;">
                    <div class="item swiper-slide" v-for="item in detailContent.events">
                      <img class="img-fluid" :src="item.img">
                      <div class="time">{{item.time}}</div>
                      <div class="events">{{$t(item.event)}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right imgRight" v-if="detailContent.model == 'img'">
            <div class="right-content">
              <div class="bk-container"
                   :class="{bkBlue:detailContent.bkColor=='blue',bkBlack:detailContent.bkColor=='black'}"></div>
              <div class="menu">
                <div class="swiper-container">
                  <div class="swiper-wrapper" style="padding: 0.375rem 0;">
                    <div class="item swiper-slide" :src="item.img" v-for="(item,index) in detailContent.imgs">
                      <img style="cursor: pointer; pointer-events:auto;" class="img-fluid" :large="item.img" :preview="detailContent.id" :src="item.img">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import Swiper from '../../../node_modules/swiper/js/swiper.min.js'
  import {WOW} from 'wowjs'
  import BigImgViwer from '@/components/common/BigImgViwer'
  import {mapGetters} from 'vuex'

  export default {
    name: 'Lantern',
    components: {
      BigImgViwer
    },
    props: {
      detailContent: {
        type: Object,
        default: function () {
          return {
            id: '',
            title: '',
            model: 'card', //card-卡片，img-图片
            bkColor: 'blue', //主要两种样式，blue,black
            events: [],
            imgs: []
          }
        }
      },
    },
    data () {
      return {
        mySwiper: null,

      }
    },
    methods: {
      clickNextItem () {
        this.mySwiper.slideNext()
      },
      clickPrevItem () {
        this.mySwiper.slidePrev()
      },
      showBigImg (img) {
      }
    },
    mounted () {
      console.log(this.detailContent.imgs);
      const wow = new WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: false,
        live: false,

      })
      wow.init()
      $('.swiper-container').bind('selectstart', function () {
        return false
      })
      if (this.detailContent.id) {
        this.mySwiper = new Swiper('.' + this.detailContent.id + ' .swiper-container', {
          loop:true,
          slidesPerView: 'auto',
          spaceBetween: this.isMobile ? '8%' : '2%',
          loopedSlides: this.isMobile ? 1 : 4,
          freeMode: false,
          observer: true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents: true,//修改swiper的父元素时，自动初始化swiper
          autoplay: {
              // 用户操作swiper之后，是否禁止autoplay，默认为true
              disableOnInteraction: false,
              delay:5000,
          },
          //  centeredSlides: true,
        })
      } else {
        this.mySwiper = new Swiper(' .swiper-container', {
          loop: true,
          slidesPerView: 'auto',
          spaceBetween: this.isMobile ? '8%' : '2%',
          loopedSlides: this.isMobile ? 1 : 4,
          freeMode: false,
          observer: true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents: true,//修改swiper的父元素时，自动初始化swiper
          autoplay: {
              // 用户操作swiper之后，是否禁止autoplay，默认为true
              disableOnInteraction: false,
              delay:5000,
          },
          //  centeredSlides: true,
        })
      }
    },
    computed: {
      ...mapGetters(['isMobile', 'lang']),
      getComponentName () {
        return 'Lantern'
      }
    }

  }
</script>

<style lang="scss" scoped>
  // .swiper-slide {
	//   transition: 300ms;
	//   transform: scale(0.9);
  //   }
  //  .swiper-slide-active,.swiper-slide-duplicate-active{
  //     transform: scale(1.0);
  // }

  .lantern {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row-reverse;
    padding: 4.25rem 0;

    .content {
      max-width: 96.25rem;
      width:90%;
      height: 30rem;
      display: flex;
      align-items: center;

      .left {
        flex: 1;
        min-width:15rem;
        margin-right:5rem;
        p {
          font-size: 2rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 400;
          color: rgba(63, 74, 93, 1);
          // line-height: 3.13rem;
          letter-spacing: 0.2rem;
        }
        span {
          font-size: 1rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 400;
          color: rgba(63, 74, 93, 1);
        }

        .common-btn {
          cursor: pointer;
          margin-top: 1.5rem;
          background-size: contain;
          width: 4.05rem;
          height: 3.375rem;
          // display: inline-block;
          float: left;
        }

        .left-btn {
          background: url("../../assets/img/common/btn_left_hexagon.png") no-repeat;
          background-size: contain;
        }

        .left-btn:hover {
          background: url("../../assets/img/common/btn_left_hexagon_active.png") no-repeat;
          background-size: contain;
        }

        .right-btn {
          margin-left: 1.25rem;
          background: url("../../assets/img/common/btn_right_hexagon.png") no-repeat;
          background-size: contain;
        }

        .right-btn:hover {
          background: url("../../assets/img/common/btn_right_hexagon_active.png") no-repeat;
          background-size: contain;
        }
      }

      .right {
        width: 100%;
        height: 100%;
        max-width: 75rem;
        display: flex;
        flex-direction: row-reverse;
        align-items: center;

        .right-content {
          position: relative;
          height: 100%;
          width: 100%;
          overflow: hidden;

          .bk-container {
            margin-left: 6rem;
            max-width: 69rem;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: left;
            align-items: center;
          }

          .bkBlue {
            background: linear-gradient(90deg, rgba(43, 158, 255, 1) 0%, rgba(50, 79, 255, 1) 100%);
          }

          .bkBlack {
            background: linear-gradient(90deg, rgba(59, 73, 98, 1) 0%, rgba(29, 38, 50, 1) 100%);
          }

          .menu {
            height: 100%;
            position: absolute;
            max-width: 75rem;
            overflow: hidden;
            z-index: 10;
            display: flex;
            align-items: center;
            top: 0;


            .item {
              width: 21rem;
              height: 22.5rem;
              background: #FFFFFF;
              float: left;
              z-index: 1000;
              margin-left: 0.1rem;
              box-shadow: 0rem 0rem 0.375rem rgba(179, 193, 218, 0.41);

              .time {
                font-size: 1.125rem;
                font-family: Arial, Source Han Sans CN;
                font-weight: 400;
                color: rgba(63, 74, 93, 1);
                line-height: 3.13rem;
                padding: 0 1.5rem;
              }

              .events {
                font-size: 0.88rem;
                font-family: Arial, Source Han Sans CN;
                font-weight: 300;
                color: rgba(63, 74, 93, 1);
                /*line-height: 4.17rem;*/
                padding: 0 1.5rem;
              }

              img, .img-viewer {
                height: 14.25rem;
                width: 21rem;
              }
            }
          }
        }
      }

      .imgRight {
        .right-content {
          position: relative;
          height: 100%;
          width: 100%;
          overflow: hidden;

          .bk-container {
            max-width: 69rem;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: left;
            align-items: center;
          }

          .menu {
            height: 100%;
            position: absolute;
            max-width: 75rem;
            overflow: hidden;
            z-index: 10;
            display: flex;
            align-items: center;


            .item {
              width: 21rem;
              height: 15.75rem;
              background: #FFFFFF;
              float: left;
              z-index: 1000;
              margin-left: 0.1rem;
              box-shadow: 0rem 0rem 0.375rem rgba(179, 193, 218, 0.41);

              .time {
                font-size: 1.125rem;
                font-family: Arial, Source Han Sans CN;
                font-weight: 400;
                color: rgba(63, 74, 93, 1);
                line-height: 3.13rem;
                padding: 0 1.5rem;
              }

              .events {
                font-size: 0.88rem;
                font-family: Arial, Source Han Sans CN;
                font-weight: 300;
                color: rgba(63, 74, 93, 1);
                /*line-height: 4.17rem;*/
                padding: 0 1.5rem;
              }

              img {
                height: 15.75rem;
                width: 21rem;
              }
            }
          }
        }
      }
    }
  }

  .visible-xs {
    .lantern {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: row-reverse;
      padding: 0rem 0;

      .content {
        max-width: 100%;
        width: 100%;
        height: 24rem;
        display: flex;
        align-items: center;
        flex-direction: column;


        .left {
          flex: 1;
          margin-right: 0;

          p {
            font-size: 1.5rem;
            font-family: Arial, Source Han Sans CN;
            font-weight: 400;
            color: rgba(63, 74, 93, 1);
            line-height: 3rem;
            letter-spacing: 0.2rem;
            text-align: center;
          }

          span {
            font-size: 0.8rem;
            font-family: Arial, Source Han Sans CN;
            font-weight: 400;
            color: rgba(63, 74, 93, 1);
          }
        }

        .right {
          width: 100%;
          height: 100%;
          max-width: 100%;
          display: flex;
          flex-direction: row-reverse;
          align-items: center;
          margin-top: 1rem;

          .right-content {
            position: relative;
            height: 100%;
            width: 100%;
            overflow: hidden;

            .bk-container {
              margin-left:0%;
              max-width: 100%;
              width:100%;
              height: 100%;
              display: flex;
              justify-content: left;
              align-items: center;
            }

            .bkBlue {
              background: linear-gradient(90deg, rgba(43, 158, 255, 1) 0%, rgba(50, 79, 255, 1) 100%);
            }

            .bkBlack {
              background: linear-gradient(90deg, rgba(59, 73, 98, 1) 0%, rgba(29, 38, 50, 1) 100%);
            }

            .menu {
              height: 100%;
              position: absolute;
              max-width: 100%;
              overflow: hidden;
              z-index: 10;
              display: flex;
              align-items: center;
              top: 0;


              .item {
                width: 15.12rem;
                height: 16.2rem;
                background: #FFFFFF;
                float: left;
                z-index: 1000;
                margin-left: 0.1rem;
                box-shadow: 0rem 0rem 0.375rem rgba(179, 193, 218, 0.41);

                .time {
                  font-size: 1rem;
                  font-family: Arial, Source Han Sans CN;
                  font-weight: 400;
                  color: rgba(63, 74, 93, 1);
                  line-height: 3.13rem;
                  padding: 0 1rem;
                }

                .events {
                  font-size: 0.8rem;
                  font-family: Arial, Source Han Sans CN;
                  font-weight: 300;
                  color: rgba(63, 74, 93, 1);
                  /*line-height: 4.17rem;*/
                  padding: 0 1rem;
                }

                img, .img-viewer {
                  height: 10.26rem;
                  width: 15.12rem;
                }
              }
            }
          }
        }

        .imgRight {
          .right-content {
            position: relative;
            height: 100%;
            width:100%;
            overflow: hidden;

            .bk-container {
              max-width: 100%;
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: left;
              align-items: center;
            }

            .menu {
              width: 100%;
              height: 100%;
              position: absolute;
              max-width: 100%;
              overflow: hidden;
              z-index: 10;
              display: flex;
              align-items: center;


              .item {
                width: 15.12rem;
                height: 11.34rem;
                background: #FFFFFF;
                float: left;
                z-index: 1000;
                margin-left: 0.1rem;
                box-shadow: 0rem 0rem 0.375rem rgba(179, 193, 218, 0.41);

                .time {
                  font-size: 1.125rem;
                  font-family: Arial, Source Han Sans CN;
                  font-weight: 400;
                  color: rgba(63, 74, 93, 1);
                  line-height: 3.13rem;
                  padding: 0 1rem;
                }

                .events {
                  font-size: 0.8rem;
                  font-family: Arial, Source Han Sans CN;
                  font-weight: 300;
                  color: rgba(63, 74, 93, 1);
                  /*line-height: 4.17rem;*/
                  padding: 0 1rem;
                }

                img {
                  height: 11.34rem;
                  width: 15.12rem;
                }
              }
            }
          }
        }
      }
    }
  }

  .english {
    .left {
        p {
          letter-spacing: 0 !important;
        }
      }
    .hidden-xs{
      .left {
        p,span{
          white-space: pre-wrap;
        }
      }
      .lantern .content .left{
        min-width:20rem;
        margin-right: 2rem;
      }
    }


    .visible-xs {
      .time {
        line-height: 2rem !important;
      }
     .lantern .content .left p{
       font-size: 1.2rem;
        letter-spacing: 0 !important;
     }
      .events {
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3;
        /*word-break: break-all;*/
        -webkit-box-orient: vertical;
        display: -webkit-box;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Lantern.vue